export const truncate = (str: string, words: number) =>
  str.split(" ").length >= words
    ? `${str.split(" ").slice(0, words).join(" ")}...`
    : str;
